export default "__VITE_ASSET__si$_5N4l__"